import { Role, User } from "@/app/auth/auth";
import React, { FC } from "react";
import { PersonalListItem } from "../molecules/PersonalListItem";
import { classNames } from "@/shared/utils/classnames";

export type PersonalListProps = JSX.IntrinsicElements["ul"] & {};

export const PersonalList: FC<PersonalListProps> = ({
  children,
  className,
  ...props
}) => {
  return (
    <ul
      role="list"
      className={classNames(
        "w-full grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 md:grid-rows-3 lg:grid-cols-3 lg:grid-rows-3 xl:grid-cols-4 xl:grid-rows-4",
        className
      )}
      {...props}
    >
      {children}
    </ul>
  );
};
